export default defineI18nLocale(async locale => {
    return {
    // navbar
        login: 'Masuk',
        register: 'Daftar',
        for_company: 'Untuk Perusahaan',
        for_jobseeker: 'Untuk Pencari Kerja',
        dashboard: 'Beranda',
        all_jobs: 'Semua Loker',
        my_job_list: 'Lamaran Saya',
        profile: 'Profil',
        notification: 'Notifikasi',
        view_all_notification: 'Lihat Semua Notifikasi',
        change_password: 'Ubah Kata Sandi',
        help_center: 'Pusat Bantuan',
        logout: 'Keluar',
        job_seeker: 'Pencari Kerja',
        'Remember Me': 'Ingat Saya',

        // footer
        contact_information: 'Informasi Kontak',
        privacy_policy: 'Kebijakan Privasi',
        terms_conditions: 'Syarat & Ketentuan',
        our_service: 'Servis Kami',
        company: 'Perusahaan',
        legal_policy: 'Hukum & Kebijakan',

        // landing page
        explore_more_jobs: 'Telusuri Lebih Banyak',
        register_now: 'Daftar Sekarang',
        posted: 'Diposting',
        landing_seo_title: 'Samurai Rekrutmen | Kerja Global, Hidup di Indonesia',
        landing_seo_description: 'Temukan peluang karier di perusahaan internasional—secara remote maupun on-site—yang dirancang untuk talenta berpengalaman global.',
        landing_seo_keywords: 'kerja global, pekerjaan remote, karier internasional, lowongan kerja, pengalaman jepang, karier',
        job_seo_title: 'Lowongan Kerja {monthYear} | Samurai Rekrutmen',
        job_seo_description: 'Temukan Lowongan Kerja di Samurai Rekrutmen. Lowongan Kerja {monthYear}',
        job_seo_keywords: 'semua lowongan kerja, pekerjaan remote, lowongan global, karier',
        job_detail_seo_not_found: 'Lowongan Tidak Ditemukan',
        job_detail_seo_default_description: 'Lihat detail lowongan dan lamar sekarang.',
        job_detail_seo_title: '{jobTitle} di {companyName}, {location} | Samurai Rekrutmen',
        job_detail_seo_description: 'Lamar {jobTitle} di {companyName}, {location}, {category}, {type}',
        job_detail_seo_keywords: '{jobTitle}, {companyName}, lowongan kerja, karier global, kerja remote',
        company_seo_not_found: 'Perusahaan Tidak Ditemukan',
        company_seo_title: 'Bekerja di {companyName} | Samurai Rekrutmen',
        company_seo_description: 'Cari dan lamar lowongan kerja di {companyName} melalui Samurai Rekrutmen, platform karier untuk talenta berpengalaman global.',
        company_seo_keywords: '{companyName}, perusahaan internasional, lowongan kerja, karier',
        company_job_seo_not_found: 'Perusahaan Tidak Ditemukan',
        company_job_seo_default_description: 'Lihat profil perusahaan dan lowongan kerja.',
        company_job_seo_title: 'Lowongan Kerja di {companyName} | Samurai Rekrutmen',
        company_job_seo_description: 'Cari dan lamar pekerjaan di {companyName} melalui Samurai Rekrutmen, menghubungkan talenta dengan peluang global dan remote.',
        company_job_seo_keywords: 'Kerja {companyName}, lowongan kerja global, karier',
        login_seo_title: 'Login | Samurai Rekrutmen',
        login_seo_description: 'Selamat datang di Samurai Rekrutmen. Login dengan akun terdaftar Anda atau lanjutkan dengan Google untuk membuka potensi karier Anda.',
        login_seo_keywords: 'login, pencari kerja, talenta global, lowongan kerja, karier',
        register_seo_title: 'Daftar | Samurai Rekrutmen',
        register_seo_description: 'Daftar Akun. Daftar sekarang untuk membuat akun dan menemukan berbagai peluang global yang menarik.',
        register_seo_keywords: 'daftar, pencari kerja, buat akun, pekerjaan global, karier',

        // job
        all_cities: 'Semua Lokasi',
        candidates_applied: 'pelamar',
        views_on_this_job: 'tampilan pada loker ini',
        search_by_keywords: 'Cari berdasarkan kata kunci',
        search: 'Cari',
        previous_slide: 'Slide sebelumnya',
        next_slide: 'Slide berikutnya',
        open_menu: 'Buka menu',
        close_menu: 'Tutup menu',

        'Welcome to': 'Selamat datang di',
        'Forgot Password?': 'Lupa kata sandi?',
        Save: 'Simpan',
        Next: 'Selanjutnya',
        'Personal Information': 'Informasi Pribadi',
        'Almost Done!': 'Hampir Selesai!',
        'Review and make any changes below': 'Tinjau dan lakukan perubahan di bawah ini',
        Edit: 'Ubah',
        'Video Introduction': 'Video Perkenalan',
        'Company Profile': 'Profil Perusahaan',
        'List Job': 'Daftar Pekerjaan',
        'People': 'Orang',
        'Successfully save job': 'Berhasil menyimpan pekerjaan',
        'All Provinces': 'Semua Provinsi',
        'Search job by title': 'Cari pekerjaan berdasarkan judul',
        'See More Jobs': 'Lihat Lebih Banyak Pekerjaan',
        'About Company': 'Tentang Perusahaan',
        'Company Gallery': 'Galeri Perusahaan',
        'COMPANY NAME': 'NAMA PERUSAHAAN',
        'Company Video': 'Video Perusahaan',
        'Company Website': 'Situs Web Perusahaan',
        'Your Life in Japan': 'Kehidupan Anda di Jepang',
        'Life in Japan': 'Kehidupan di Jepang',
        'Your Life': 'Kehidupan Anda',
        Gender: 'Jenis Kelamin',
        Address: 'Alamat',
        'Select Region': 'Pilih Wilayah',
        'Select Specific Location': 'Pilih Lokasi Spesifik',
        'Portfolio Link': 'Tautan Portofolio',
        'Basic Information': 'Informasi Dasar',
        'Additional Information': 'Informasi Tambahan',
        'Category Interested': 'Kategori yang Diminati',
        'Wishing Job Type': 'Jenis Pekerjaan yang Diinginkan',
        Skills: 'Keahlian',
        make_your_application_stand_out:
            'Buat aplikasi Anda lebih menonjol dengan mencantumkan keahlian Anda. Ketuk tombol di bawah ini untuk menambahkan kemampuan terbaik Anda.',
        'Add Skill': 'Tambahkan Keahlian',
        Languages: 'Bahasa',
        Language: 'Bahasa',
        Speaking: 'Berbicara',
        Writing: 'Menulis',
        Listening: 'Mendengar',
        'Search or enter language': 'Cari atau masukkan bahasa',
        "I don't have any": 'Tidak ada',
        'I am a pass JFT exam': 'Saya lulus ujian JFT',
        'Pass JFT': 'Lulus JFT',
        expand_your_opportunities:
            'Perluas peluang Anda dengan menunjukkan bahasa yang Anda kuasai. Klik tombol di bawah ini untuk menambahkan bahasa.',
        'Add Languages': 'Tambahkan Bahasa',
        'Additional Documents': 'Dokumen Tambahan',
        'Upload your additional documents':
            'Unggah dokumen tambahan Anda (mis. sertifikat kerja dari luar negeri)',
        'Upload Documents': 'Unggah Dokumen',
        'Education Detail': 'Detail Pendidikan',
        'Adding an education section':
            'Menambahkan bagian pendidikan menyoroti kualifikasi Anda dan membuat Anda menjadi kandidat yang lebih kuat',
        'Job Experience': 'Pengalaman Kerja',
        'japan.experience': 'Bekerja di Jepang',
        'Enhance your experience section':
            'Meningkatkan bagian pengalaman Anda dapat secara signifikan meningkatkan peluang Anda mendapatkan pekerjaan impian',
        'Key Achievement': 'Pencapaian Utama',
        'Successfully led a cross-functional team... ':
            'Berhasil memimpin tim lintas fungsi... ',
        Previous: 'Sebelumnya',
        Other: 'Lainnya',
        'Example : Name of the LPK, Person Name, etc...':
            'Contoh : Nama LPK, Nama Orang, dll...',
        'Skip All': 'Lewati Semua',
        'Skip This Section': 'Lewati Sesi Ini',
        'Future Plans': 'Rencana Masa Depan',
        'Career Questionnaire': 'Kuesioner Karier',
        'Enter Your Future Plans Details':
            'Masukkan Detail Rencana Masa Depan Anda',

        // --- MATCHED QUESTION KEYS ---
        'What System Did You Choose To Go To Japan':
            'Kategori visa mana yang Anda pilih untuk pergi ke Jepang?',
        'When did you depart and come back from Japan':
            'Kapan Anda berangkat dan kembali dari Jepang',
        'When did you depart and come back from Overseas?':
            'Kapan Anda berangkat dan kembali ?',
        'What Job Category were you working at?':
            'Kategori Pekerjaan apa yang Anda jalani sebelumnya?',
        'What Job Category were you working at':
            'Kategori pekerjaan apa yang Anda jalani',
        'How many workers were there at your work':
            'Berapa banyak pekerja di tempat kerja Anda',
        'How many workers were there at your work?':
            'Berapa banyak pekerja di tempat kerja Anda?',
        'How were the percentage of MEN workers at your work':
            'Berapa persentase pekerja LAKI-LAKI di tempat kerja Anda',
        'How were the percentage of MEN workers at your work?':
            'Berapa persentase pekerja LAKI-LAKI di tempat kerja Anda?',
        'How often do you speak Japanese at your work':
            'Seberapa sering Anda berbicara bahasa Jepang di tempat kerja Anda',
        'How often do you speak Japanese at your work?':
            'Seberapa sering Anda berbicara bahasa Jepang di tempat kerja Anda?',
        'Do you wish to go back to Japan for work again':
            'Apakah Anda ingin kembali ke Jepang untuk bekerja lagi',
        'Do you wish to go back to Japan for work again?':
            'Apakah Anda ingin kembali ke Jepang untuk bekerja lagi?',
        'How did you spend your day off in Japan':
            'Bagaimana Anda menghabiskan hari libur di Jepang',
        'How did you spend your day off in Japan?':
            'Bagaimana Anda menghabiskan hari libur di Jepang?',
        'Which work environment do you prefer':
            'Lingkungan kerja seperti apa yang Anda sukai',
        'Which work environment do you prefer?':
            'Lingkungan kerja seperti apa yang Anda sukai?',
        'Which character type do you think you are in working environment?':
            'Menurut Anda, tipe karakter seperti apa Anda di lingkungan kerja?',
        'Life in Overseas': 'Kehidupan di Luar Negeri',
        'Fill your career questionnaire so we can match you with the right companies.':
            'Isi kuesioner karier Anda agar kami dapat mencocokkan Anda dengan perusahaan yang tepat.',
        'Which country did you work in?': 'Di negara mana Anda bekerja?',
        'When did you go overseas and return?': 'Kapan Anda berangkat dan kembali dari luar negeri?',
        'I am still Overseas': 'Saya masih di luar negeri',
        'How did you go overseas?': 'Bagaimana Anda berangkat ke luar negeri?',
        'Explain how': 'Jelaskan bagaimana',
        'Which country did you go to, and what was your visa type?':
            'Negara mana yang Anda tuju, dan apa jenis visa Anda?',
        'Visa': 'Visa',
        'Tell us what your visa type': 'Beritahu kami jenis visa Anda',
        'Why did you leave your previous job / school studies?':
            'Mengapa Anda meninggalkan pekerjaan / studi sekolah sebelumnya?',
        'Which language did you primarily use at work, and how often?':
            'Bahasa apa yang paling sering Anda gunakan di tempat kerja, dan seberapa sering?',
        'Why are you looking for a new job / Why did you return to Indonesia?':
            'Mengapa Anda mencari pekerjaan baru / Mengapa Anda kembali ke Indonesia?',
        'What type of workplace culture fits you best? (Select up to 2)':
            'Budaya kerja seperti apa yang paling cocok untuk Anda? (Pilih maksimal 2)',
        'Team-oriented': 'Berorientasi Tim',
        'I work best collaborating closely with others': 'Saya bekerja paling baik berkolaborasi erat dengan orang lain',
        'Independent': 'Mandiri',
        'I prefer working with autonomy and self-direction': 'Saya lebih suka bekerja dengan otonomi dan arahan sendiri',
        'Structured': 'Terstruktur',
        'I thrive with clear processes and defined roles': 'Saya berkembang dengan proses yang jelas dan peran yang terdefinisi',
        'Flexible': 'Fleksibel',
        'I prefer adapting and managing my own workload': 'Saya lebih suka menyesuaikan dan mengatur beban kerja saya sendiri',
        'Fast-paced': 'Serba Cepat',
        'I enjoy dynamic, high-energy environments': 'Saya menikmati lingkungan yang dinamis dan berenergi tinggi',
        'Stable': 'Stabil',
        'I prefer consistent routines and steady-paced work': 'Saya lebih suka rutinitas yang konsisten dan pekerjaan berirama stabil',
        'Choose the one describes more like yourself in general':
            'Pilih yang paling menggambarkan diri Anda secara umum',
        'Choose the one describes more like yourself in general?':
            'Pilih yang paling menggambarkan diri Anda secara umum?',
        'What are your top 3 interests in work?':
            'Apa 3 minat utama Anda dalam pekerjaan?',
        'Which province do you prefer to work at?':
            'Di provinsi mana Anda lebih suka bekerja?',
        'Which province do you prefer to work at':
            'Di provinsi mana Anda lebih suka bekerja',
        'Which province do you prefer to work at in Indonesia?':
            'Di provinsi mana Anda lebih suka bekerja di Indonesia?',
        "Are you willing to try new category of job from what you've done before":
            'Apakah Anda bersedia mencoba kategori pekerjaan baru dari yang sebelumnya Anda kerjakan',
        "Are you willing to try new category of job from what you've done before?":
            'Apakah Anda bersedia mencoba kategori pekerjaan baru dari yang sebelumnya Anda kerjakan?',
        'How is your English Level?': 'Bagaimana tingkat Bahasa Inggris Anda?',
        'Please write your most important thing in life':
            'Tuliskan hal terpenting dalam hidup Anda',

        // --- NEWLY ADDED KEYS (From Component Strings) ---
        'Your Answer': 'Jawaban Anda',
        'Choose Category': 'Pilih Kategori',
        Beginner: 'Pemula',
        Intermediate: 'Menengah',
        Advanced: 'Mahir',
        'Writing skills': 'Keterampilan Menulis',
        'Reading skills': 'Keterampilan Membaca',
        'Speaking skills': 'Keterampilan Berbicara',
        'Start Date': 'Tanggal Mulai',
        'End Date': 'Tanggal Selesai',
        Reason: 'Alasan',
        'Writing Skill': 'Kemampuan Menulis',
        'Reading Skill': 'Kemampuan Membaca',
        'Speaking Skill': 'Kemampuan Berbicara',
        '#1 Interest': 'Minat #1',
        '#2 Interest': 'Minat #2',
        '#3 Interest': 'Minat #3',

        // Dropdown Options
        Ginoujisyuu: 'Magang Teknis (Ginoujisyuu)',
        Tokuteiginou: 'Pekerja Berketerampilan Spesifik (Tokuteiginou)',
        Gijinkoku:
            'Teknisi/Spesialis Humaniora/Layanan Internasional (Gijinkoku)',
        Ryuugaku: 'Pelajar (Ryuugaku)',
        '1-10': '1-10',
        '11-30': '11-30',
        '31-50': '31-50',
        'Over 100': 'Lebih dari 100',
        'Over 1000': 'Lebih dari 1000',
        'About 50%': 'Sekitar 50%',
        'Almost 100% ': 'Hampir 100%',
        'Less than 30%': 'Kurang dari 30%',
        'Most of working hours': 'Sebagian besar jam kerja',
        Sometimes: 'Kadang-kadang',
        Rarely: 'Jarang',
        ' Work hard to get well paid': 'Bekerja keras untuk gaji yang baik',
        'Work but leave on time': 'Bekerja tapi pulang tepat waktu',
        'With Japanese friends': 'Dengan teman orang Jepang',
        'With non-Japanese friends': 'Dengan teman bukan orang Jepang',
        Alone: 'Sendiri',
        'Work alone': 'Bekerja sendiri',
        'With team': 'Dengan tim',
        'Team Leader(Decision Maker)': 'Pemimpin Tim (Pengambil Keputusan)',
        'Balancer (Encourage team member)':
            'Penyeimbang (Penyemangat anggota tim)',
        'Specialist (Prefer to concentrate by own)':
            'Spesialis (Lebih suka konsentrasi sendiri)',
        'Extraversion (Enjoy being the center of attention)':
            'Ekstrovert (Suka menjadi pusat perhatian)',
        'introversion (Prefer to observe than center of attention)':
            'Introvert (Lebih suka mengamati daripada menjadi pusat perhatian)',
        'Extraversion or introversion': 'Ekstrovert atau Introvert',
        'Sensing (Think based on reality)':
            'Sensing (Berpikir berdasarkan kenyataan)',
        'Intuition (Enjoy ideas and imagining)':
            'Intuisi (Menikmati ide dan membayangkan)',
        'Sensing or Intuition': 'Sensing atau Intuisi',
        'Thinking (Logical thinking when making decision)':
            'Berpikir (Berpikir logis saat mengambil keputusan)',
        'Feeling (Your value is the key of decision)':
            'Merasa (Nilai Anda adalah kunci keputusan)',
        'Thinking or Feeling': 'Berpikir atau Merasa',
        'Judging (Prefer to have settled life)':
            'Menilai (Lebih suka kehidupan yang mapan)',
        'Perceiving (Prefer to have challenges in life)':
            'Memahami (Lebih suka tantangan dalam hidup)',
        'Judging or Perceiving': 'Menilai atau Memahami',

        // --- OLD/UNUSED KEYS (Kept for safety in case used elsewhere) ---
        'How did you know Samurai Rekrutmen':
            'Bagaimana Anda mengetahui Samurai Rekrutmen',
        'Add New': 'Tambahkan Baru',
        'About Your Future': 'Tentang Masa Depan Anda',
        'This section will explain about':
            'Bagian ini akan menjelaskan tentang harapan Anda di masa depan sehingga perusahaan yang lebih cocok dapat menemukan Anda dengan mudah',
        'Which work style do you prefer in the future':
            'Gaya kerja seperti apa yang Anda sukai di masa depan',
        'Which work style do you prefer in the future?':
            'Gaya kerja seperti apa yang Anda sukai di masa depan?',
        'Which work environment do you prefer in the future':
            'Lingkungan kerja seperti apa yang Anda sukai di masa depan',
        'Which work type do you prefer':
            'Jenis kerja seperti apa yang Anda sukai',
        'First Interest': 'Minat Pertama',
        'Second Interest': 'Minat Kedua',
        'Third Interest': 'Minat Ketiga',
        'Big Category': 'Kategori Besar',
        'Small Category': 'Kategori Kecil',
        'This interest has already been selected':
            'Minat ini sudah dipilih',
        'What are your expectations from the company and your superior':
            'Apa harapan Anda dari perusahaan dan atasan Anda',
        'Based on your skill and ability, What are your salary expectations':
            'Berdasarkan keahlian dan kemampuan Anda, berapa ekspektasi gaji Anda',
        'When would you be available to start if hired':
            'Kapan Anda tersedia untuk mulai bekerja jika diterima',
        'What is your career goal?':
            'Apa tujuan karier Anda?',
        'When can you start interviewing?': 'Kapan Kamu bisa mulai wawancara?',
        'When can you start working?': 'Kapan Kamu siap mulai bekerja',
        'Enter your personal information': 'Masukkan informasi pribadi Anda',
        'Upload Profile Photo': 'Unggah Foto Profil',
        'Enter your first name': 'Masukkan nama depan Anda',
        'Enter your last name': 'Masukkan nama belakang Anda',
        'Select gender': 'Pilih jenis kelamin',
        'Select your region': 'Pilih wilayah Anda',
        'Select your province': 'Pilih provinsi Anda',
        'Enter your address': 'Masukkan alamat Anda',
        'Enter your email': 'Masukkan email Anda',
        'Enter your phone number': 'Masukkan nomor telepon Anda',
        'First Name*': 'Nama Depan*',
        'First Name': 'Nama Depan',
        'Last Name*': 'Nama Belakang*',
        'Last Name': 'Nama Belakang',
        'Gender*': 'Jenis Kelamin*',
        'Date of Birth*': 'Tanggal Lahir*',
        'Select date': 'Pilih tanggal',
        'Select Country': 'Pilih Negara',
        'Select Province': 'Pilih Provinsi',
        'Address Line 1': 'Alamat Baris 1',
        'Address Line 2': 'Alamat Baris 2',
        'Landmark & City': 'Patokan & Kota',
        'State/Province': 'Negara Bagian/Provinsi',
        'Zip Code': 'Kode Pos',
        'Make this default shipping address':
            'Jadikan ini alamat pengiriman default',
        Country: 'Negara',
        Region: 'Wilayah',
        Province: 'Provinsi',
        'Email*': 'Email*',
        'Phone Number*': 'Nomor Telepon*',
        'Short Description': 'Deskripsi Singkat',
        'Write a 2–3 sentence summary about yourself and strengths':
            'Tuliskan 2–3 kalimat ringkasan tentang diri Anda dan kelebihan Anda',
        'Specific Location': 'Lokasi Spesifik',
        'Job Type': 'Jenis Pekerjaan',
        'Add your languages': 'Tambahkan bahasa Anda',
        'Complete your profile': 'Lengkapi profil Anda',
        'We see this is your first login, please fill this form':
            'Kami melihat ini adalah login pertama Anda, silakan isi formulir ini',
        'Your Future Plans': 'Rencana Masa Depan Anda',
        'Working in Overseas': 'Bekerja di Luar Negeri',
        'Working Abroad': 'Bekerja di Luar Negeri',
        Personal: 'Pribadi',
        Basic: 'Tambahan',
        Additional: 'Tambahan',
        'Complete Profile': 'Lengkapi Profil',
        Answered: 'Dijawab',
        'Write Answer (Ex: Microsoft Skills: Word, Excell, PowerPoint)':
            'Tulis Jawaban (Contoh: Keterampilan Microsoft: Word, Excel, PowerPoint)',
        'Write Answer': 'Tulis Jawaban',
        'Choose Answer': 'Pilih Jawaban',
        'Choose answer': 'Pilih jawaban',
        'About Your Life': 'Tentang Hidup Anda',
        'How did you know Samurai Rekrutmen?':
            'Bagaimana Anda mengetahui Samurai Rekrutmen?',
        'What are you?': 'Siapa anda?',
        'What Job experience do you have?': 'Pengalaman kerja apa yang Anda miliki?',
        '(If you are a fresh graduate, part-time job is also allowed)': '(Jika Anda lulusan baru, pekerjaan paruh waktu juga diperbolehkan)',
        'Add Job Experience': 'Tambahkan Pengalaman Bekerja',
        'What skills can you bring to next job':
            'Keterampilan apa yang dapat Anda bawa ke pekerjaan berikutnya?',
        Skill: 'Keterampilan',
        Level: 'Tingkat',
        'work period':
            'Dalam periode kerja terlama, berapa banyak pekerja yang ada di tempat kerja Anda?',
        'Job Category': 'Kategori',
        'Choose Job': 'Pilih Pekerjaan',
        'greatest achievement':
            'Apa pencapaian terbesar Anda dalam pekerjaan sebelumnya?',
        'How do you handle challenges at work':
            'Bagaimana Anda menangani tantangan di tempat kerja?',
        'What motivates you in your work':
            'Apa yang memotivasi Anda dalam bekerja?',
        'Why did you leave your previous job':
            'Mengapa Anda meninggalkan pekerjaan Anda sebelumnya? (Jika berlaku)',
        'How do you manage your daily life':
            'Bagaimana Anda mengelola kehidupan sehari-hari Anda?',
        morning: 'Pagi',
        daytime: 'Siang Hari',
        evening: 'Malam hari',
        'Day Off': 'Hari Libur',
        'province do you prefer to work in Indonesia':
            'Provinsi mana yang Anda pilih untuk bekerja di Indonesia?',
        option: 'Pilihan',
        'About Yourself': 'Tentang Diri Anda',
        'This section will explain about what kind of person you are':
            'Bagian ini akan menjelaskan seperti apa diri Anda, sehingga perusahaan dapat melihat potensi Anda selain hanya keterampilan.',
        'Wishes of Future Job': 'Harapan untuk Pekerjaan di Masa Depan',
        'Enter company name': 'Masukkan nama perusahaan',
        'Company Name': 'Nama Perusahaan',
        'Select job category': 'Pilih kategori pekerjaan',
        Category: 'Kategori Pekerjaan',
        'Position Level': 'Tingkat Posisi',
        'Allowed Image':
            'Diizinkan: .jpg, .jpeg, .png dengan ukuran maksimum 2MB',
        'Recommendation tools for edit photo':
            'Rekomendasi alat untuk mengedit foto',
        'Upload Your Resume': 'Unggah Resume Anda',
        'Enter your basic information': 'Masukkan informasi dasar Anda',
        'Skills and Level': 'Keterampilan dan Tingkatannya',
        'Search or enter skill': 'Cari atau masukkan keahlian',
        'Other Skill': 'Keahlian Lainnya',
        'Select Level': 'Pilih tingkatannya',
        'Select Skills': 'Pilih Keahlian',
        'Enter your skill': 'Masukkan keahlian Anda',
        'Employment certificate from overseas':
            'Misalnya: Sertifikat pekerjaan dari luar negeri',
        'Upload Additional Documents':
            'Unggah Dokumen Tambahan (Format PDF, maksimal 2MB)',
        Education: 'Pendidikan',
        'Add Education': 'Tambahkan Pendidikan',
        Qualification: 'Kualifikasi',
        'Select qualification': 'Pilih kualifikasi',
        'Field of Study': 'Bidang Studi',
        'Search or enter field of study': 'Cari atau masukkan bidang studi',
        'Enter institution name': 'Masukkan nama institusi',
        'University / School Name': 'Nama Institusi',
        'Education Description': 'Deskripsi Pendidikan',
        'Enter your score': 'Masukkan nilai Anda',
        Score: 'Nilai',
        'From date': 'Dari Tanggal',
        Description: 'Deskripsi',
        Role: 'Peran',
        'Select role': 'Pilih Peran',
        'Enter Role Name': 'Masukkan Nama Peran',
        'Role Name': 'Nama Peran',
        'Role Permissions': 'Izin Peran',
        'Administrator Access': 'Akses Administrator',
        'Select All': 'Pilih Semua',
        Specify: 'Spesifik',
        'Select specify': 'Pilih spesifik',
        'Select position level': 'Pilih tingkat posisi',
        'Job Description': 'Deskripsi Pekerjaan',
        'I am still working on this role': 'Saya masih bekerja pada peran ini',
        'Wishing Location of work place':
            'Lokasi yang Diinginkan untuk Tempat Kerja',
        'Date of Birth': 'Tanggal Lahir',
        Answer: 'Jawaban',
        'Other Informations': 'Informasi Lainnya',
        'Life in Overseas & Future Plan': 'Kehidupan di Luar Negeri & Rencana Masa Depan',
        Interest: 'Ketertarikan',
        'Which visa category did you choose to go to Japan?':
            'Kategori visa mana yang Anda pilih untuk pergi ke Jepang?',
        'I am still in Japan': 'Saya masih berada di Jepang',
        category: 'Kategori',
        'Position and role description': 'Deskripsi posisi dan peran',
        'We provide automatic generated Resume':
            'Kami menyediakan resume yang dibuat secara otomatis',
        'Resume detail based from your profile information':
            'Detail resume berdasarkan informasi profil Anda',
        'Generate Resume': 'Buat Resume',
        'Register an Account': 'Daftar Akun',
        'Already have an account': 'Sudah punya akun? ',
        Register: 'Daftar',
        Password: 'Kata Sandi',
        'Confirmation Password': 'Konfirmasi Kata Sandi',
        'Do you have work experience in Japan':
            'Apakah memiliki pengalaman bekerja di Jepang?',
        'Do you have work experience in Japan?':
            'Apakah memiliki pengalaman bekerja di Jepang?',
        'Sign in instead': ' Masuk sebagai gantinya',
        'I agree to': 'Saya setuju dengan',
        'privacy policy': 'kebijakan privasi',
        'terms conditions': 'syarat dan ketentuan',
        or: 'atau',
        'New on our platform': 'Baru di platform kami? ',
        'Create an account': ' Buat akun',
        Later: 'Nanti',
        'Complete Now!': 'Lengkapi Sekarang!',
        'Please complete all forms before saving the data':
            'Mohon lengkapi seluruh bagian formulir sebelum menyimpan data',
        'Complete Your Information Message':
            'Lengkapi informasi Anda untuk menerima rekomendasi pekerjaan yang sesuai dengan profil Anda.',
        'Complete Your Information Confirm Message':
            'Lengkapi informasi Anda untuk menerima rekomendasi pekerjaan yang sesuai dengan profil Anda.',
        'Complete Your Information Confirm Question':
            'Lengkapi Informasi Pribadi Anda Sekarang?',
        'Complete Your Information Cancel Message':
            'Berhenti Berlangganan Dibatalkan!!',
        Cancel: 'Batal',
        'Sure, Skip Now': 'Lewati Saja',
        'Skip Message':
            'Mengisi detail Anda dapat meningkatkan peluang Anda untuk mendapatkan rekomendasi pekerjaan yang sesuai dengan profil Anda.',
        'Skip Confirm Message':
            'Lengkapi informasi Anda untuk menerima rekomendasi pekerjaan yang sesuai dengan profil Anda.',
        'Skip Confirm Question': 'Anda yakin ingin melewati?',
        'Skip Cancel Message': 'Berhenti Berlangganan Dibatalkan!',
        'Please select region first': 'Silahkan pilih wilayah terlebih dahulu',
        'Uploading Files': 'Unggah File',
        'What They Have Learned': 'Apa yang mereka pelajari',
        'What sort of answer would you write if you needed to write here?':
            'Apa jenis jawaban yang akan Anda tulis jika Anda perlu menulis di sini?',
        'Please answer this question in one sentence.':
            'Silakan jawab pertanyaan ini dalam satu kalimat.',
        'Welcome back': 'Selamat datang kembali',
        'Search and apply a job, customized for Indonesian employees who have worked in Japan.':
            'Cari dan lamar pekerjaan, disesuaikan untuk karyawan Indonesia yang pernah bekerja di Jepang.',
        'All Cities': 'Semua Kota',
        'Find jobs': 'Temukan pekerjaan',
        Search: 'Cari',
        'Job Recommendation': 'Rekomendasi Pekerjaan',
        'All Jobs': 'Semua Pekerjaan',
        'Applied Job': 'Pekerjaan yang Dilamar',
        'Number of your Applied Job': 'Jumlah Pekerjaan yang Anda Lamar',
        Jobs: 'Pekerjaan',
        'Progress Alert': 'Info Progres',
        'Go Back to Previous Step?': 'Kembali ke Langkah Sebelumnya?',
        'You have unsaved changes in this step. Going back will discard your current input.':
            'Anda memiliki perubahan yang belum disimpan di langkah ini. Kembali akan membuang input Anda saat ini.',
        'Stay on This Step': 'Tetap di Langkah Ini',
        'Go Back Anyway': 'Kembali Saja',
        'My Job List': 'Daftar Lamaran',
        'No Job Progress': 'Tidak Ada Progres Lamaran',
        'Find job openings and start applying!':
            'Temukan lowongan pekerjaan dan mulai melamar!',
        'Date posted': 'Tanggal diposting',
        applicants: 'pelamar',
        'Company Overview': 'Gambaran Perusahaan',
        'Company Detail': 'Detail Perusahaan',
        'REGISTRATION NO': 'NO REGISTRASI',
        WEBSITE: 'WEBSITE',
        'PHONE NO': 'NO TELEPON',
        'NO EMPLOYEE': 'NO KARYAWAN',
        'WORKING HOURS': 'JAM KERJA',
        ADDRESS: 'ALAMAT',
        'EMPLOYEE BENEFIT': 'MANFAAT KARYAWAN',
        'No Notifications Yet': 'Belum Ada Notifikasi',
        'Job Lists': 'Daftar Pekerjaan',
        'Jobs related to': 'Pekerjaan yang terkait dengan ',
        'Sort By': 'Urutkan Berdasarkan',
        'Sort by': 'Urutkan Berdasarkan',
        Relevance: 'Relevansi',
        'Highest Salary': 'Gaji Tertinggi',
        Newest: 'Terbaru',
        'Clear Filter': 'Hapus Filter',
        'JFT Status': 'Status JFT',
        'Date Posted': 'Tanggal Diposting',
        'jobs.showing': 'Tampilkan {count} dari total {total}',
        'No Matching Jobs Found': 'Tidak Ada Pekerjaan yang Cocok Ditemukan',
        'Complete your interest categories to get job recommendations':
            'Lengkapi kategori minat Anda untuk mendapatkan rekomendasi pekerjaan',
        'No Matching Jobs Found.': 'Tidak Ada Pekerjaan yang Cocok Ditemukan.',
        "We couldn't find what you searched for.":
            'Kami tidak dapat menemukan yang ingin Anda cari.',
        people: 'orang',
        Contact: 'Kontak',
        'Not Required': 'Tidak Diperlukan',
        'Not required': 'Tidak Diperlukan',
        'Need to pass': 'Diperlukan',
        Details: 'Detail',
        'Job Status': 'Status Pekerjaan',
        'Application Status': 'Status Lamaran',
        'In Review': 'Sedang Direview',
        Draft: 'Draft',
        Rejected: 'Ditolak',
        Approved: 'Disetujui',
        Open: 'Terbuka',
        Paused: 'Dijeda',
        Closed: 'Ditutup',
        Active: 'Aktif',
        'Waiting Review': 'Menunggu Review',
        Shortlist: 'Dipilih',
        Contacting: 'Dihubungi',
        Interviewed: 'Diwawancarai',
        Hired: 'Diterima',
        Withdraw: 'Mengundurkan Diri',
        Status: 'Status',
        Applied: 'Dilamar',
        'Easy Apply': 'Lamar',
        'Share Job': 'Bagikan Pekerjaan',
        'You can copy and send it or share it on your social media':
            'Anda dapat menyalin dan mengirimnya atau membagikannya di media sosial Anda',
        'COPY LINK': 'SALIN TAUTAN',
        'Last 3 Days': '3 Hari Terakhir',
        'Last 7 Days': '7 Hari Terakhir',
        'Last 30 Days': '30 Hari Terakhir',
        'Complete Your Profile': 'Lengkapi Profil Anda',
        'Complete your profile to start applying for jobs right away.':
            'Lengkapi profil Anda untuk mulai melamar pekerjaan segera.',
        'Update Profile': 'Perbarui Profil',
        'Are you sure want to submit': 'Anda yakin ingin mengirimkan',
        'Make sure all the data you fill in is correct':
            'Pastikan semua data yang Anda isi sudah benar',
        Submit: 'Kirim',
        Contacted: 'Dihubungi',
        'Saved Jobs': 'Disimpan',
        'No Applications Yet': 'Belum Ada Lamaran',
        'Discover More Jobs': 'Temukan Lebih Banyak Lowongan',
        'No Saved Jobs': 'Tidak Ada Lowongan yang Disimpan',
        'Save the job openings you are interested in!':
            'Simpan lowongan pekerjaan yang Anda minati!',
        'Search job title': 'Cari judul pekerjaan',
        'My Profile': 'Profil Saya',
        'Future Plan': 'Rencana Masa Depan',
        'Your Profile Is Under Review': 'Profil Anda Sedang Direview',
        'We’re currently reviewing your profile. You’ll be notified as soon as it’s approved and ready for job applications.':
            'Kami sedang meninjau profil Anda. Anda akan diberitahu segera setelah disetujui dan siap untuk melamar pekerjaan.',
        Male: 'Laki-laki',
        Female: 'Perempuan',
        'Edit Basic Information': 'Edit Informasi Dasar',
        'Additional Info': 'Info Tambahan',
        beginner: 'Pemula',
        intermediate: 'Menengah',
        advanced: 'Mahir',
        Present: 'Sekarang',
        to: 'sampai',
        Experience: 'Pengalaman',
        Add: 'Tambah',
        Read: 'Baca',
        Write: 'Tulis',
        Create: 'Buat',
        Update: 'Perbarui',
        Delete: 'Hapus',
        'Change Password': 'Ubah Kata Sandi',
        'Successfully change password': 'Berhasil mengubah kata sandi',
        'Current Password': 'Kata Sandi Saat Ini',
        'New Password': 'Kata Sandi Baru',
        'Confirm New Password': 'Konfirmasi Kata Sandi Baru',
        'Password Requirements': 'Persyaratan Kata Sandi',
        'Minimum 6 characters long - the more, the better':
            'Minimal 6 karakter - semakin banyak, semakin baik',
        'At least one uppercase and lowercase character':
            'Setidaknya satu karakter huruf besar dan kecil',
        'At least one number':
            'Setidaknya satu angka',
        'Save Changes': 'Simpan Perubahan',
        'Help Center': 'Pusat Bantuan',
        'You Still Have a Question': 'Ada Pertanyaan Lain?',
        "If you can't find question in our FAQ, you can contact us. We'll answer you shortly!":
            'Jika Anda tidak dapat menemukan pertanyaan di FAQ kami, Anda dapat menghubungi kami. Kami akan segera menjawab Anda!',
        'Best way to get a quick answer':
            'Cara terbaik untuk mendapatkan jawaban cepat',
        'We are always happy to help': 'Kami selalu senang membantu',
        English: 'Bahasa Inggris',
        Indonesian: 'Bahasa Indonesia',
        Japanese: 'Bahasa Jepang',
        'Date applied': 'Diterapkan pada',
        'Apply Now': 'Lamar Sekarang',
        'Detail Job': 'Detail Pekerjaan',
        'Fill out your career questionnaire so we can match you with the right companies.':
            'Isi kuesioner karir Anda sehingga kami dapat mencocokkan Anda dengan perusahaan yang tepat.',
        'Add Authenticator App': 'Tambahkan Aplikasi Otentikasi',
        'Authenticator Apps': 'Aplikasi Otentikasi',
        'Using an authenticator app like Google Authenticator, Microsoft Authenticator, Authy, or 1Password, scan the QR code. It will generate a 6 digit code for you to enter below.':
            'Menggunakan aplikasi otentikasi seperti Google Authenticator, Microsoft Authenticator, Authy, atau 1Password, pindai kode QR. Ini akan menghasilkan kode 6 digit untuk Anda masukkan di bawah ini.',
        "If you're having trouble using the QR code, select manual entry on your app":
            'Jika Anda mengalami kesulitan menggunakan kode QR, pilih entri manual di aplikasi Anda.',
        'Add Address for future billing':
            'Tambahkan Alamat untuk penagihan di masa mendatang',
        'Edit Card': 'Edit Kartu',
        'Add New Card': 'Tambah Kartu Baru',
        'Card Number': 'Nomor Kartu',
        'Edit your saved card details': 'Edit detail kartu yang Anda simpan',
        'Add your card details': 'Tambahkan detail kartu Anda',
        Name: 'Nama',
        Expiry: 'Kadaluarsa',
        'Verify Your Mobile SMS': 'Verifikasi SMS Mobile Anda',
        'Enter your mobile phone number with country code and  we will send you a verification code.':
            'Masukkan nomor ponsel Anda dengan kode negara dan kami akan mengirimkan kode verifikasi kepada Anda.',
        'Phone Number': 'Nomor Telepon',
        'User Information': 'Informasi Pengguna',
        'Updating user details will receive a privacy audit.':
            'Memperbarui detail pengguna akan menerima audit privasi.',
        Username: 'Nama Pengguna',
        'Billing Email': 'Email Penagihan',
        'Tax Id': 'ID Pajak',
        'Upgrade Plan': 'Tingkatkan Paket',
        'Your Current Plan': 'Paket Anda Saat Ini',
        'Choose the best plan for user.': 'Pilih paket terbaik untuk pengguna.',
        'Choose a plan': 'Pilih paket',
        Upgrade: 'Tingkatkan',
        month: 'bulan',
        'Cancel Subscription': 'Batalkan Langganan',
        Cancelled: 'Dibatalkan',
        Unsubscribed: 'Berhenti Berlangganan',
        'Your subscription cancelled successfully.':
            ' Langganan Anda berhasil dibatalkan.',
        'Unsubcription Cancelled!!': 'Berhenti Berlangganan Dibatalkan!!',
        'Are you sure want to cancel your subscription?':
            'Apakah Anda yakin ingin membatalkan langganan Anda?',
        'Are you sure to cancel your subscription?':
            'Apakah Anda yakin ingin membatalkan langganan Anda?',
        mark_all_as_read: 'Tandai sudah dibaca',
        'If the email verification is not found, please check the Spam or Trash folder.':
            'Jika verifikasi email tidak ditemukan, silakan periksa folder Spam atau Sampah.',
        'We just sent a verification link to your email.':
            'Kami baru saja mengirim tautan verifikasi ke email Anda.',
        'Click on it and active your account!':
            'Klik di atasnya dan aktifkan akun Anda!',
        'Resend Verification Link': 'Kirim Ulang Tautan Verifikasi',
        'This field is required': 'Kolom ini wajib diisi',
        'The Email field must be a valid email':
            'Kolom Email harus berupa email yang valid',
        'Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars':
            'Kolom harus berisi setidaknya satu karakter huruf besar, huruf kecil, dan digit dengan minimal 6 karakter',
        'The Confirm Password field confirmation does not match':
            'Konfirmasi Kata Sandi tidak cocok',
        'Enter number between': 'Masukkan angka antara',
        and: 'dan',
        'Maximum experience is 5': 'Pengalaman maksimal adalah 5',
        'Maximum skill is 5': 'Keahlian maksimal adalah 5',
        'Please fill in all fields in the current row first':
            'Silakan isi semua kolom di baris saat ini terlebih dahulu',
        'Please fill out all current skill fields first':
            'Silakan isi semua kolom keahlian saat ini terlebih dahulu',
        'At least one experience row is required':
            'Setidaknya satu baris pengalaman diperlukan',
        'At least one education row is required':
            'Setidaknya satu baris pendidikan diperlukan',
        'At least one skill is required':
            'Setidaknya satu keahlian diperlukan',
        'About Overseas Life': 'Tentang Kehidupan di Luar Negeri',
        'Do you wish to go back overseas for work again?': 'Apakah Anda ingin kembali bekerja di luar negeri?',
        'Resume successfully uploaded': 'Resume berhasil diunggah',
        'Enter a valid integer': 'Masukkan bilangan bulat yang valid',
        'This field must be an integer':
            'Kolom ini harus berupa bilangan bulat',
        'The field must be a valid URL': 'Kolom harus berupa URL yang valid',
        'The field may only contain alphabetic characters':
            'Kolom hanya boleh berisi karakter alfabet',
        'The field may only contain alphabetic characters and spaces':
            'Kolom hanya boleh berisi karakter alfabet dan spasi',
        'The field may only contain alpha-numeric characters':
            'Kolom hanya boleh berisi karakter alfanumerik',
        'The field may only contain alpha-numeric characters and dashes':
            'Kolom hanya boleh berisi karakter alfanumerik dan tanda hubung',
        'The field may only contain letters, numbers, dashes and underscores':
            'Kolom hanya boleh berisi huruf, angka, tanda hubung, dan garis bawah',
        'The field may only contain letters, numbers, spaces, dashes and underscores':
            'Kolom hanya boleh berisi huruf, angka, spasi, tanda hubung, dan garis bawah',
        'The Alpha field may only contain alphabetic characters':
            'Kolom Alfabet hanya boleh berisi karakter alfabet',
        'URL is invalid': 'URL tidak valid',
        'The Regex field format is invalid': 'Format kolom Regex tidak valid',
        'The Min Character field must be at least':
            'Minimal Karakter harus berisi setidaknya',
        characters: 'karakter',
        Maximum: 'Maksimal',
        'All Character are not valid': 'Semua Karakter tidak valid',
        'Maximum salary field must be greater than minimum salary':
            'Maksimal gaji harus lebih besar dari gaji minimal',
        'Minimum number is': 'Jumlah minimum adalah',
        'Can not be negative number': 'Tidak boleh angka negatif',
        'Click here if you did not receive an email from us.':
            'Klik di sini jika tidak mendapatkan email dari kami.',
        'You can resend now': 'Kamu bisa mengirim kembali',
        'Resend in ': 'Mengirim ulang dalam ',

        'Add More Job  Experience': 'Tambahkan Pengalaman Kerja Lainnya',
        'Add More Skill': 'Tambahkan Keahlian Lainnya',
        'Cannot copy': 'Tidak dapat menyalin',
        'Create Account': 'Buat Akun',
        'Enter your additional information': 'Masukkan informasi tambahan Anda',
        'Maximum score is 100': 'Nilai maksimum adalah 100',
        'Most applicants': 'Pelamar terbanyak',
        'Most views': 'Tayangan terbanyak',
        'New password cannot be the same as current password':
            'Kata sandi baru tidak boleh sama dengan kata sandi saat ini',
        'No future plans shared yet.':
            'Belum ada rencana masa depan yang dibagikan.',
        'Only PDF and DOC files are allowed':
            'Hanya file PDF dan DOC yang diperbolehkan',
        'Save Card for future billing?':
            'Simpan Kartu untuk penagihan di masa mendatang?',
        'Successfully remove saved job':
            'Berhasil menghapus lowongan yang disimpan',
        'Successfully resend verification link':
            'Berhasil mengirim ulang tautan verifikasi',
        'Successfully saved job': 'Berhasil menyimpan lowongan',
        'Successfully update job': 'Berhasil memperbarui lowongan',
        'Successfully update profile!': 'Berhasil memperbarui profil!',
        'Successfully withdraw from application': 'Berhasil menarik lamaran',
        'Successfully submit application': 'Berhasil mengirim lamaran',
        'Successfully submit job for review':
            'Berhasil mengirim pekerjaan untuk ditinjau',
        'Successfully update job status':
            'Berhasil memperbarui status pekerjaan',
        'Profile submitted successfully!': 'Profil berhasil dikirim!',
        'Unsubscription Cancelled!!': 'Berhenti Berlangganan Dibatalkan!!',
        'Use as a billing address?': 'Gunakan sebagai alamat penagihan?',
        'User current plan is standard plan':
            'Paket pengguna saat ini adalah paket standar',
        'DD MMM YYYY': 'DD MMM YYYY',
        'DD MMM YYYY, hh:mm A': 'DD MMM YYYY, hh:mm A',
        'DD MMM, hh:mm A': 'DD MMM, hh:mm A',
        'DD MMMM YYYY': 'DD MMMM YYYY',
        'MMMM YYYY': 'MMMM YYYY',
        'YYYY-MM-DD': 'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
        'Yesterday, hh:mm A': 'Kemarin, hh:mm A',
        '[Today], hh:mm A': '[Hari Ini], hh:mm A',
        '[Yesterday], hh:mm A': '[Kemarin], hh:mm A',
        INDUSTRY: 'Industri',
        pdf: 'PDF',
        'submitted...!!': 'Dikirim...!!',
        views: 'Tayangan',
        Yes: 'Ya',
        No: 'Tidak',
        'Are you sure?': 'Apakah Anda yakin?',
        'Are you sure want to withdraw from this application?':
            'Apakah Anda yakin ingin menarik diri dari lamaran ini?',
        'Withdraw Job': 'Ya, Tarik Lamaran',
        'Apply to': 'Lamar ke',
        'Submit Application': 'Kirim Lamaran',

        'Want to submit selected jobs for review?':
            'Ingin mengirimkan loker yang dipilih untuk ditinjau?',
        'Submit to Review': 'Kirim untuk Ditinjau',
        'Want to re-submit selected jobs for review?':
            'Ingin mengirimkan ulang loker yang dipilih untuk ditinjau?',
        'Re-Submit': 'Kirim Ulang',
        'Want to pause selected jobs?': 'Ingin menjeda loker yang dipilih?',
        Pause: 'Jeda',
        'Want to close selected jobs?': 'Ingin menutup loker yang dipilih?',
        Close: 'Tutup',
        'Want to publish selected jobs?':
            'Ingin mempublikasikan loker yang dipilih?',
        Publish: 'Publikasikan',
        'Want to re-open selected jobs?':
            'Ingin membuka kembali loker yang dipilih?',
        'Re-Open': 'Buka Kembali',
        'Describe your character...': 'Deskripsikan karakter Anda...',
        'Describe your work style...': 'Deskripsikan gaya kerja Anda...',
        'Which prefecture were you working in Japan before?':
            'Di prefektur mana Anda bekerja di Jepang sebelumnya?',
        'Were currently reviewing your profile. Youll be notified as soon as its approved and ready for job applications.':
            'Kami sedang meninjau profil Anda. Anda akan diberitahu segera setelah disetujui dan siap untuk melamar pekerjaan.',
        'Your Profile Has Been Rejected': 'Profil Anda Telah Ditolak',
        'Loading...': 'Memuat...',
        'No data available': 'Tidak ada data yang tersedia',
        cv: {
            title: 'Daftar Riwayat Hidup',
            name: 'Nama',
            dob: 'Tanggal lahir',
            gender: 'Jenis kelamin',
            nationality: 'Kebangsaan',
            types_of_visas: 'Jenis Visa',
            visa: 'Visa',
            period: 'Periode',
            period_in_japan: 'Periode di Jepang',
            target_location: 'Lokasi Pekerjaan yang Diutamakan',
            employment_history: 'Riwayat Pekerjaan',
            company_name: 'Nama Perusahaan',
            working_period: 'Periode Kerja',
            position_and_duties: 'Posisi & Tugas',
            position: 'Posisi',
            duties: 'Tugas',
            monthly_salary: 'Gaji Bulanan',
            language_ability: 'Kemampuan Berbahasa',
            writing: 'Menulis',
            listening: 'Mendengarkan',
            speaking: 'Berbicara',
            educational_background: 'Latar Belakang Pendidikan',
            computer_skills: 'Keterampilan Komputer',
            overseas_experience: 'Pengalaman di Luar Negeri',
            overseas_work_history: 'Riwayat Pekerjaan di Luar Negeri',
            skills_for_your_next_job: 'Keterampilan untuk pekerjaan berikutnya',
            expected_salary: 'Gaji yang Diharapkan',
            negotiable_based_on_responsibilities_and_work_location:
                'per bulan (nego sesuai tanggung jawab dan lokasi kerja)',
            target_for_the_next_10_years: 'Target 10 Tahun Mendatang',
            start_interviewing: 'Siap Untuk Wawancara',
            start_working: 'Siap Bekerja',
            career_goal: 'Target Karier',
            target_industry: 'Industri Pekerjaan yang Diutamakan',
            available: 'Kapan Anda Bisa Mulai?',
            reason_for_leaving_previous_job: 'Alasan Meninggalkan Pekerjaan Sebelumnya',
            about: 'Tentang Saya',
            achievement: 'Pencapaian Utama',
            'cv.dob': 'Tanggal Lahir',
            'cv.educational_background': 'Latar Belakang Pendidikan',
            'cv.employment_history': 'Riwayat Pekerjaan',
            'cv.expected_salary': 'Gaji yang Diharapkan',
            'cv.gender': 'Jenis Kelamin',
            'cv.language_ability': 'Kemampuan Berbahasa',
            'cv.name': 'Nama',
            'cv.nationality': 'Kebangsaan',
            'cv.period_in_japan': 'Periode di Jepang',
            'cv.target_location': 'Lokasi Pekerjaan yang Diutamakan',
            'cv.skills_for_your_next_job':
                'Keterampilan untuk Pekerjaan Berikutnya',
            'cv.target_for_the_next_10_years': 'Target 10 Tahun Mendatang',
            'cv.title': 'Daftar Riwayat Hidup',
            'cv.types_of_visas': 'Jenis Visa',
    },

        onboarding_notification: {
            title: 'Profil Anda Belum Lengkap',
            step1: 'Tahap 1 - Riwayat Hidup (Belum Selesai)',
            step2: 'Tahap 2 - Rencana Masa Depan (Belum Selesai)',
            step3: 'Tahap 3 - Data Pribadi (Belum Selesai)',
            step4: 'Tahap 4 - Informasi Dasar (Belum Selesai)',
            step5: 'Tahap 5 - Pengalaman Kerja (Belum Selesai)',
            msg: 'Silakan lengkapi profil Anda agar kami dapat menyesuaikan kualifikasi Anda dengan perusahaan yang tepat.',
            btn_action: 'Perbarui Sekarang',
    },

        whyus: {
            section_title: 'Mengapa Samurai Rekrutmen?',
            listing: [
                {
                    title: 'Pencocokan Ahli',
                    description:
                        'Kami mencocokkan keahlian spesifik Anda dengan peluang yang tepat di Jepang.',
        },
                {
                    title: 'Pertumbuhan Karir',
                    description:
                        'Dukungan untuk perjalanan Anda, mulai dari lamaran hingga masa depan Anda di Jepang.',
        },
                {
                    title: 'Mitra Terpercaya',
                    description:
                        'Menghubungkan Anda dengan perusahaan-perusahaan yang terverifikasi dan andal.',
        }
            ]
        },
        'Additional Question': 'Pertanyaan Tambahan',
        'Choose Resume': 'Pilih Resume',
        'Review Application': 'Tinjauan Aplikasi',
        'Please select resume': 'Silakan pilih resume',
        resume: {
            useUpload: 'Gunakan Resume Unggahan',
            useAutoGenerate: 'Gunakan Resume Buatan Otomatis',
            autoGenerateDesc: 'Kami membuat Resume berdasarkan info akun Anda',
    },
        filter: {
            filters: 'Filter',
            jobType: 'Tipe Pekerjaan',
            jlptLevel: 'Tingkat JLPT',
            jftStatus: 'Status JFT',
            datePosted: 'Tanggal Diposting',
            salary: 'Gaji',
            specializations: 'Spesialisasi',
            notRequired: 'Tidak Diwajibkan',
            needToPass: 'Wajib Lulus',
            last3Days: '3 Hari Terakhir',
            last7Days: '7 Hari Terakhir',
            last30Days: '30 Hari Terakhir',
            showResult: 'Tampilkan Hasil',
            reset: 'Atur Ulang'
        },
        "company_not_found": "Perusahaan Tidak Ditemukan",
        "company_not_found_desc": "Profil perusahaan yang Anda cari tidak ditemukan, tidak tersedia, atau telah dihapus.",
        "page_not_found": "Halaman Tidak Ditemukan",
        "page_not_found_desc": "Ups, sepertinya halaman yang Anda cari tidak dapat ditemukan. Anda dapat kembali ke halaman sebelumnya atau gunakan tombol di bawah ini untuk kembali ke beranda.",
        "back_to_home": "Kembali ke Beranda",
        'Similar Jobs': 'Pekerjaan Serupa',
        'Deadline': 'Batas Waktu',
        'Score/GPA': 'Nilai/IPK',
        'Confirmation': 'Konfirmasi',
        'Is this information correct?': 'Apakah informasi ini sudah benar?',
        'Download PDF': 'Unduh PDF',
        'Read More': 'Baca Selengkapnya',
        'Read Less': 'Sembunyikan',
        "I don't have JLPT level": 'Saya tidak memiliki level JLPT',
        "job_not_found": 'Pekerjaan Tidak Ditemukan',
        "job_not_found_desc": 'Pekerjaan yang Anda cari tidak ditemukan, tidak tersedia, atau telah dihapus.',
        "back_to_jobs": 'Kembali ke Daftar Pekerjaan',
        Apply: 'Lamar',
        'Still in Japan': 'Masih di Jepang',
        'Profile reapplication failed': 'Pengajuan ulang profil gagal',
        'Failed to update profile data': 'Gagal memperbarui data profil',
        'Please complete your profile before continue': 'Harap lengkapi profil Anda sebelum melanjutkan',
        'Job Search Results': 'Hasil Pencarian Pekerjaan',
        'Computer Skills': 'Keahlian Komputer',
        'What is your status?': 'Apa status Anda?',
        'Why do you think you deserve this salary': 'Mengapa Anda merasa layak mendapatkan gaji ini',
        'What is your career goal': 'Apa tujuan karir Anda',
        'Add Computer Skill': 'Tambah Keahlian Komputer',
        'Make your application stand out by listing your skills': 'Buat lamaran Anda lebih menonjol dengan mencantumkan keahlian Anda',
        'Computer Skills (software and tools)': 'Keahlian Komputer (perangkat lunak dan alat)',
        'Complete Information': 'Lengkapi Informasi',
        Email: 'Email',
        'Enter email': 'Masukkan email',
        'Do you have overseas experience?': 'Apakah Anda memiliki pengalaman di luar negeri?',
        'Edit Education': 'Edit Pendidikan',
        'Edit Experience': 'Edit Pengalaman',
        'Edit Additional Info': 'Edit Info Tambahan',
        'Edit Future Plans': 'Edit Rencana Masa Depan',
        'Job Detail Preview': 'Pratinjau Detail Pekerjaan',
        'Please note that this page is only a preview of the job detail.':
            'Harap diperhatikan bahwa halaman ini hanya merupakan tampilan preview dari detail pekerjaan.',
        'Your Account is Under Review': 'Akun Anda Sedang Dalam Tinjauan',
        'Your account is currently under review by our team. Please wait for further updates.':
            'Maaf, akun Anda saat ini sedang ditinjau oleh tim kami. Mohon tunggu pembaruan lebih lanjut.',
        "I'm Understand": 'Saya Mengerti',
        'What are the most important things for your future?':
            'Apa hal terpenting bagi masa depan Anda?',
        'Write your plans here...': 'Tulis rencana Anda di sini...',
        'Copy Text': 'Salin Teks',
        Copied: 'Tersalin',
        'Got it!': 'Mengerti!',
        'Subscription Successful!': 'Berlangganan Berhasil!',
        'Check Your Email': 'Periksa Email Anda',
        'Thank you for subscribing to our newsletter. You will receive the latest job opportunities in your inbox.':
            'Terima kasih telah berlangganan newsletter kami. Anda akan menerima lowongan kerja terbaru di inbox Anda.',
        'We have sent a verification link to {email}. Please check your inbox to complete the subscription.':
            'Kami telah mengirimkan tautan verifikasi ke {email}. Silakan periksa kotak masuk Anda untuk menyelesaikan langganan.',
        DETAILS: 'DETAIL',
        Salary: 'Gaji',
        'Email Contact': 'Kontak Email',
        'Additional Job Info': 'Info Pekerjaan Tambahan',
        'JLPT Level': 'Tingkat JLPT',
        'JFT Status Level': 'Tingkat Status JFT',
        'Select one': 'Pilih salah satu',
        'Do you have work experience overseas?': 'Apakah Anda memiliki pengalaman kerja di luar negeri?',
        Continue: 'Lanjutkan',
  }
})
